import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button, LoadMore, MediaBox } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import EnumService from 'services/enum2';
import OrderService from 'services/order';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import CommonFns from 'functions/common.ts';
import Download from 'components/download.js';
import Http from 'services/http2';
import Big from 'big.js';
import ScheduleService from 'services/schedule';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Link } from 'react-router-dom';

function PlanScheduleDetail(props) {
  const Config = {
    purchase: {
      title: '供应计划排程详情',
      apiPath: '/schedule/detailHeader',
      publishApiPath: '/schedule/import/publish',
      customerNameKey: 'companyName',
      companyCodeKey: 'companyCode',
      vendorNameKey: 'innerVendorName',
      tabs: ['排程详情', '差异待确认'],
      arrEnumField: [
        {
          mainKey: 'B02_Sch_Batch_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'billNo',
      venderDetailLink: '/mp/purchase/plan/schedule/vendor/detail',
      detailParams: { detailType: 1 },

      wfmCode: '1017'
    },
    sale: {
      title: '客户交货排程详情',
      apiPath: '/schedule/detailHeader',
      customerNameKey: 'companyName',
      vendorNameKey: 'innerCustomerName',
      tabs: ['排程详情', '差异待确认'],
      arrEnumField: [
        {
          mainKey: 'B02_Sch_Batch_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'billNo',
      detailParams: { detailType: 2, callerType: 2 }
    }
  };

  const config = Config[props.type];

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });
  const [list, setList] = useState([]);
  const [currNavIndex, setCurrNavIndex] = useState(Number);
  const [unConfirmVendors, setUnConfirmVendors] = useState([]); //差异待确认供应商列表

  //处理详情数据
  self.afterGetDetail = function (data) {
    getList();
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  // function handleBoxState(idx) {
  //   boxState[idx] = !boxState[idx];
  //   setBoxState(boxState);
  //   forceUpdate();
  // }

  function getList() {
    let postbody = {
      callerType: 1,
      billNo: self.id,
      detailType: 1,
      pageSize: 100,
      pageNum: 1,
      companyCode: companyCode,
      apiPath: '/schedule/detailList'
    };
    if (!self.isPurchase) {
      postbody.callerType = 2;
      postbody.detailType = 2;
      postbody.validStatus = 1;
    }

    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let lists = response.data.content || [];
        lists.forEach(item => {
          EnumService.getValue('B02_Sch_Order_Item_Status', item.status).then(
            value => {
              item.statusName = value;
            }
          );
          // 排程数据处理
          let obj = {};
          let prodPlanTotal = 0;
          let estimateStockQty = Big(item.stockQty || 0); //预计库存

          item.detailList.forEach(row => {
            let nPlus, nMinus;
            if (detail.version === 2) {
              //生产计划
              prodPlanTotal += row.prodPlanQty || 0; //计算生产计划总量
              nMinus = row.prodPlanQty || 0;
            } else {
              nMinus = row.scheduleQty;
            }
            if (
              (self.isPurchase && [0, 1, 2].includes(item.status)) ||
              (!self.isPurchase && [0, 1].includes(item.status))
            ) {
              //采购方：未答交；供应商：未答交
              nPlus = row.scheduleQty;
            } else {
              nPlus = row.replyQty;
            }
            estimateStockQty = estimateStockQty.plus(nPlus).minus(nMinus);
            row.estimateStockQty = parseFloat(estimateStockQty.toString());
            obj[row.scheduleDate] = row;
          });
          item.prodPlanQty = prodPlanTotal;
          item.estimateStockQty = parseFloat(estimateStockQty.toString());
          item.objItemList = obj;

          //销售方
          item.isConfirmFlag = item.confirmFlag === 1;
        });
        setList(lists);
      }
    });
  }

  //获取差异待确认供应商列表
  function getUnConfirmVendors() {
    let postbody = {
      companyCode: companyCode,
      billNo: self.id,
      apiPath: '/schedule/diffUnConfirmVendors'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let unConfirmVendorsList = response.data || [];
        unConfirmVendorsList.forEach(item => {
          EnumService.getValue('B02_Sch_Order_Status', item.status).then(
            value => {
              item.statusName = value;
              forceUpdate();
            }
          );
        });
        setUnConfirmVendors(unConfirmVendorsList);
      }
    });
  }

  //发送
  function handlePublish() {
    let postbody = getPostbody(config.publishApiPath);
    postbody.detailType = 1;
    ScheduleService.handlePublish(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      billNo: self.id,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  // 切换tab
  function handleNav(type) {
    setCurrNavIndex(Number(type));
    if (Number(type) === 0 && self.isPurchase) {
      getList();
    }
    if (Number(type) === 1 && self.isPurchase) {
      getUnConfirmVendors();
    }
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      {detail.status > 0 && (
        <div className="m-tab-container">
          <ul className="m-flex-box">
            {config.tabs.map((item, index) => (
              <li
                key={index}
                onClick={() => {
                  handleNav(index);
                }}
                className={
                  currNavIndex === index ? 'm-flex-item curr' : 'm-flex-item'
                }
              >
                {(index !== 1 ||
                  (index === 1 && [3, 7].includes(detail.status))) && (
                  <span className="name">{item}</span>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
      {currNavIndex === 0 && (
        <div className="m-details-container">
          <div className="m-details-item">
            <div className="details-item-title">
              <label>基础信息</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  {self.isPurchase && (
                    <li>
                      <span className="field-label">采购方</span>
                      <div className="field-value">{detail.companyName}</div>
                    </li>
                  )}
                  {!self.isPurchase && (
                    <li>
                      <span className="field-label">客户名称</span>
                      <div className="field-value">
                        {detail[config.vendorNameKey]}
                      </div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">计划编号</span>
                    <div className="field-value">{detail.batchNo}</div>
                  </li>
                  {!self.isPurchase && (
                    <li>
                      <span className="field-label">业务员</span>
                      <div className="field-value">{detail.salesman}</div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">发布时间</span>
                    <div>
                      {formatDate(detail.publishTime, 'YYYY-MM-DD HH:mm:ss')}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">发布人</span>
                    <div className="field-value">
                      {detail.createEmployeeName}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">计划区间</span>
                    <div className="field-value">
                      {formatDate(detail.schStartDate, 'YYYY-MM-DD')} -
                      {formatDate(detail.schEndDate, 'YYYY-MM-DD')}
                    </div>
                  </li>
                  {!self.isPurchase && (
                    <li>
                      <span className="field-label">是否允许分批答交</span>
                      <div className="field-value">
                        {detail.partialReplyFlag === 1 ? '是' : '否'}
                      </div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">计划说明</span>
                    <div className="field-value">{detail.schDesc}</div>
                  </li>
                  {self.isPurchase && (
                    <li>
                      <span className="field-label">历史版本</span>
                      <div className="field-value">{detail.oldBatchNo}</div>
                    </li>
                  )}

                  <li>
                    <span className="field-label">计划类型</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>

                  <li>
                    <span className="field-label">状态</span>
                    <div className="field-value">
                      <span
                        className={
                          'u-sign ' +
                          CommonFns.getStatusClass(
                            'B02_Sch_Order_Status',
                            detail.status
                          )
                        }
                      >
                        {detail.statusName}
                      </span>
                    </div>
                  </li>

                  {/* 审批流状态 仅开启后才显示 */}
                  {self.isPurchase && updateTs > 0 && workflow.isActive && (
                    <li>
                      <span className="field-label">审批环节</span>
                      <div className="field-value">
                        <WorkflowStatus workflow={workflow} />
                      </div>
                    </li>
                  )}
                  {/* 审批流按钮 */}
                  {self.isPurchase && updateTs > 0 && workflow.isActive && (
                    <li>
                      <span className="field-label">审批操作</span>
                      <div className="field-value">
                        <WorkflowButtons
                          companyCode={companyCode}
                          id={self.id}
                          workflow={workflow}
                          detail={detail}
                          onChange={() => {
                            self.getDetail();
                          }}
                        />
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>

          {/*排程明细 */}
          {!Util.isEmpty(list) && (
            <div className="m-details-item">
              <div className="details-item-title">
                <label>排程明细</label>
              </div>

              <div className="details-item-content">
                {list.map((item, index) => (
                  <div className="content-line line-list-item" key={index}>
                    <div className="line-list-item-title">
                      <span>序号 {index + 1}</span>
                    </div>

                    <ul className="field-list">
                      <li>
                        <span className="field-label">产品编码</span>
                        <div className="field-value">{item.prodCode}</div>
                      </li>
                      <li>
                        <span className="field-label">产品名称</span>
                        <div className="field-value">{item.prodName}</div>
                      </li>
                      <li>
                        <span className="field-label">产品规格（特征值）</span>
                        <div className="field-value">
                          {item.prodScale} {item.prodFeature}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">确认说明</span>
                        <div className="field-value">{item.confirmDesc}</div>
                      </li>
                      {self.isPurchase && (
                        <li>
                          <span className="field-label">自定义项</span>
                          <div className="field-value">{item.dynamicValue}</div>
                        </li>
                      )}
                      {self.isPurchase && (
                        <li>
                          <span className="field-label">供应商</span>
                          <div className="field-value">
                            {item.innerVendorName}({item.innerVendorCode})
                          </div>
                        </li>
                      )}
                      <li>
                        <span className="field-label">部门/工厂</span>
                        <div className="field-value">
                          {item.profitCenterCode}/{item.profitCenterName}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">采购单号</span>
                        <div className="field-value">{item.poErpNoShow}</div>
                      </li>
                      <li>
                        <span className="field-label">备注</span>
                        <div className="field-value">{item.remark}</div>
                      </li>
                      <li>
                        <span className="field-label">订单待出</span>
                        <div className="field-value">
                          {formatNumber(item.waitDeliveryQty, decimalPlace.QTY)}
                        </div>
                      </li>
                      {self.isPurchase && (
                        <li>
                          <span className="field-label">库存数量</span>
                          <div className="field-value">
                            {formatNumber(item.stockQty, decimalPlace.QTY)}
                          </div>
                        </li>
                      )}
                      <li>
                        <span className="field-label">单据状态</span>
                        <div className="field-value">{item.statusName}</div>
                      </li>
                      <li>
                        <span className="field-label">差异原因</span>
                        <div className="field-value">{item.diffDesc}</div>
                      </li>
                      <li>
                        <span className="field-label">生产计划</span>
                        <div className="field-value">
                          {detail.version === 2
                            ? formatNumber(item.prodPlanQty, decimalPlace.QTY)
                            : ''}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">排程数量</span>
                        <div className="field-value">
                          {formatNumber(
                            item.scheduleTotalQty,
                            decimalPlace.QTY
                          )}
                        </div>
                      </li>
                      {self.isPurchase && (
                        <li>
                          <span className="field-label">确认数量</span>
                          <div className="field-value">
                            {[0, 1, 2].indexOf(item.status) === -1 &&
                            item.replyTotalQty
                              ? formatNumber(
                                  item.replyTotalQty,
                                  decimalPlace.QTY
                                )
                              : ''}
                          </div>
                        </li>
                      )}
                      {!self.isPurchase && (
                        <li>
                          <span className="field-label">确认数量</span>
                          <div className="field-value">
                            {item.status !== 1 && item.replyTotalQty
                              ? formatNumber(
                                  item.replyTotalQty,
                                  decimalPlace.QTY
                                )
                              : formatNumber(
                                  item.scheduleTotalQty,
                                  decimalPlace.QTY
                                )}
                          </div>
                        </li>
                      )}
                      <li>
                        <span className="field-label">预计库存</span>
                        <div className="field-value">
                          {formatNumber(
                            item.estimateStockQty,
                            decimalPlace.QTY
                          )}
                        </div>
                      </li>
                    </ul>
                    <div className="order-detail-more">
                      {self.isPurchase &&
                        item.detailList &&
                        item.detailList.map((row, i) => (
                          <ul className="field-list" key={i + 1}>
                            <li>
                              <span className="field-label">日期</span>
                              <div className="field-value">
                                {formatDate(row.scheduleDate, 'YYYY-MM-DD')}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">生产计划</span>
                              <div className="field-value">
                                {detail.version === 2
                                  ? formatNumber(
                                      row.prodPlanQty,
                                      decimalPlace.QTY
                                    )
                                  : ''}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">排程数量</span>
                              <div className="field-value">
                                {formatNumber(
                                  row.scheduleQty,
                                  decimalPlace.QTY
                                )}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">确认数量</span>
                              <div className="field-value">
                                {[0, 1, 2].indexOf(item.status) === -1
                                  ? formatNumber(
                                      row.scheduleQty,
                                      decimalPlace.QTY
                                    )
                                  : ''}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">预计库存</span>
                              <div className="field-value">
                                {formatNumber(
                                  row.estimateStockQty,
                                  decimalPlace.QTY
                                )}
                              </div>
                            </li>
                          </ul>
                        ))}
                      {!self.isPurchase &&
                        item.detailList &&
                        item.detailList.map((row, i) => (
                          <ul className="field-list" key={i + 1}>
                            <li>
                              <span className="field-label">日期</span>
                              <div className="field-value">
                                {formatDate(row.scheduleDate, 'YYYY-MM-DD')}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">排程数量</span>
                              <div className="field-value">
                                {formatNumber(
                                  row.scheduleQty,
                                  decimalPlace.QTY
                                )}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">确认数量</span>
                              <div className="field-value">
                                {item.status === 1
                                  ? formatNumber(
                                      row.scheduleQty,
                                      decimalPlace.QTY
                                    )
                                  : formatNumber(
                                      row.replyQty,
                                      decimalPlace.QTY
                                    )}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">预计库存</span>
                              <div className="field-value">
                                {formatNumber(
                                  row.estimateStockQty,
                                  decimalPlace.QTY
                                )}
                              </div>
                            </li>
                          </ul>
                        ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      {currNavIndex === 1 && (
        <div className="m-details-item">
          <div className="details-item-content">
            {unConfirmVendors.map((item, index) => (
              <Link
                to={`${config.venderDetailLink}/${companyCode}/${item.scheduleNo}`}
                key={index}
                className="content-line line-list-item"
              >
                <div className="line-list-item-title">
                  <span>序号 {index + 1}</span>
                  <div className="more">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass(
                          'B02_Sch_Order_Status',
                          item.status
                        )
                      }
                    >
                      {item.statusName}
                    </span>
                  </div>
                </div>

                <ul className="field-list">
                  <li>
                    <span>供应商编码</span>
                    <div>{item.innerVendorCode}</div>
                  </li>
                  <li>
                    <span>供应商名称</span>
                    <div>{item.innerVendorName}</div>
                  </li>
                  <li>
                    <span>计划物料 {item.totalProd}</span>
                  </li>
                  <li>
                    <span>差异物料 {item.diffProdCount}</span>
                  </li>
                </ul>
              </Link>
            ))}
            {unConfirmVendors.length === 0 && (
              <LoadMore showLine> 暂无数据</LoadMore>
            )}
          </div>
        </div>
      )}

      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10020202') &&
            [0].includes(detail.status) &&
            workflow.data &&
            workflow.data['schedule_publish_1'].complete && (
              <Button
                type="default"
                onClick={() => {
                  handlePublish();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                确认发出
              </Button>
            )}
        </div>
      )}

      <Modal></Modal>
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
    </div>
  );
}

PlanScheduleDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanScheduleDetail);
